import React, { useState, useEffect } from 'react';

const API_URL = window.location.origin;

export function VerifyEmailPage() {
    const [status, setStatus] = useState('verifying');
    const [message, setMessage] = useState('');

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');

        if (token) {
            setStatus('error');
            setMessage('Токен подтверждения не найден');
            return;
        }

        fetch(`${API_URL}/api/auth/verify-email?token=${token}`)
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    setStatus('success');
                    setMessage(data.message);
                    // Через 3 секунды перенаправляем на страницу входа
                    setTimeout(() => {
                        window.location.href = '/';
                    }, 3000);
                } else {
                    setStatus('error');
                    setMessage(data.error || 'Ошибка подтверждения email');
                }
            })
            .catch(() => {
                setStatus('error');
                setMessage('Ошибка соединения с сервером');
            });
    }, []);

    return (
        <div className="auth-page">
            <div className="auth-container">
                <div className="auth-card">
                    <div className="auth-header">
                        <h1>HydraVPN</h1>
                        <p>Подтверждение email</p>
                    </div>

                    <div className="verify-status">
                        {status === 'verifying' && (
                            <div className="verify-loading">
                                <div className="spinner"></div>
                                <p>Подтверждение email...</p>
                            </div>
                        )}

                        {status === 'success' && (
                            <div className="verify-success">
                                <div className="success-icon">✅</div>
                                <p>{message}</p>
                                <p>Перенаправление на страницу входа...</p>
                            </div>
                        )}

                        {status === 'error' && (
                            <div className="verify-error">
                                <div className="error-icon">❌</div>
                                <p>{message}</p>
                                <button onClick={() => window.location.href = '/'}>
                                    Вернуться на главную
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}